import rate from './rate';
import breakdown from './breakdown';
import './legend.css';

export default {
  rate,
  breakdown,
};
